export const splitUrl = url => {
    const search = url.substring(1);

    return search ? JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}') : 0;
};
